<!--
 SearchBar Component
 This is the component that receives user input (search) and triggers a search.
 devs@droxit.de
 Copyright (c) 2020 droxIT GmbH
-->

<template>
  <div id="rocketsearch-searchbar" v-click-inside="clickInside">
    <b-input-group size="lg">
      <b-form-input
          @keyup.enter="rocketsearch(); activateStats(); $event.target.blur();"
          @input="rocketsearch(); activateTimeout();"
          v-model="searchInput"
          id="rocketsearch-search-input"
          :placeholder="$t('search_input')"
          autocomplete="off"
          @focus="suggestsVisibility = 'visible'"
          @blur="suggestsVisibility = 'invisible'"
      />
      <b-input-group-append id="rocketsearch-search-icon-container" is-text>
        <b-icon id="rocketsearch-search-icon" icon="search"></b-icon>
      </b-input-group-append>
      <div class="list-group list-group-flush rocketsearch-mobile-suggest-item" :class="suggestsVisibility">
      <button v-for="(val,index) in suggests"
              :key="index"
              :data-id="index"
              class="list-group-item list-group-item-action"
              v-on:mousedown="clickSuggest">
          {{val}}
      </button>
    </div>
    </b-input-group>
  </div>
</template>

<script>
  export default {
    name: 'SearchBar',
    data: function () {
      return {
        lastInput: '',
        searchInput: '',
        timer: null,
        suggests: [],
        suggestsVisibility: 'invisible'
      }
    },
    created() {
      // send stats when window is closed
      window.addEventListener('beforeunload', () => {
        if(this.searchInput !== this.lastInput && this.searchInput.length > 2){
          this.resetTimer();
          this.lastInput = this.searchInput;
          this.$root.$emit('StatsEvent', this.searchInput)
        }
      });
    },
    mounted() {
      this.$root.$on('RocketSuggestClickedEvent', (suggest) => {
        this.searchInput = suggest;
        this.rocketsearch();
      });
      this.$root.$on('RocketSuggestUpdatedEvent', (suggests) => {
        this.suggests = suggests;
      });
    },
    methods: {
      rocketsearch: function () {
        this.$root.$emit('RocketSearchEvent', this.searchInput);
      },
      // send stats when enter is clicked
      activateStats: function () {
        if(this.lastInput !== this.searchInput && this.searchInput.length > 2) {
          this.resetTimer();
          this.lastInput = this.searchInput;
          this.$root.$emit('StatsEvent', this.searchInput);
        }
      },
      // send stats when typing timeout is done
      activateTimeout: function () {
        this.resetTimer();
        if(this.lastInput !== this.searchInput && this.searchInput.length > 2) {
          this.$root.$emit('StartTimeoutEvent', this.searchInput);
          let term = this.searchInput;
          // Set timer so that only when timeout event is done without interruption lastInput will be changed
          this.timer = setTimeout(function (){
            this.lastInput = term;
          }, 3000);
        }
      },
      resetTimer(){
         if (this.timer) {
            clearTimeout(this.timer);
            this.timer = null;
          }
      },
      clickInside: function () {
        this.$root.$emit('clickInsideEvent');
        this.$root.$emit('RocketSearchEvent', this.searchInput);
      },
      clickSuggest: function (e) {
        this.$root.$emit('RocketSuggestClickedEvent', e.target.innerHTML.trim());
      }
    }
  }
</script>
<style lang="scss" scoped>
</style>